var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container__grid"},[_c('CourseBaseForm',{attrs:{"course":_vm.course,"readonly":!_vm.hasPermission(_vm.Permission.COURSE_EDIT)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }